import { useNavigate } from 'react-router-dom'
import { BRAND_NAME } from '@/shared/brand'
import { useFeed } from '@/shared/hooks/useFeed'
import { useMatches } from '@/shared/hooks/useMatches'

export function Dashboard() {
  const navigate = useNavigate()
  const { data: feedProfiles, isLoading: feedLoading } = useFeed(10, { refetchOnMount: 'always' })
  const { data: matches, isLoading: matchesLoading } = useMatches()

  const hasFeed = (feedProfiles?.length ?? 0) > 0
  const matchCount = matches?.length ?? 0

  return (
    <div className="flex min-h-screen flex-col bg-white dark:bg-gray-900">
      <header className="border-b border-gray-200 p-5 dark:border-gray-700">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">{BRAND_NAME}</h1>
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">Главный экран</p>
          </div>
          <button
            type="button"
            onClick={() => navigate('/settings')}
            className="rounded-full bg-gray-100 px-3 py-2 text-sm font-semibold text-gray-800 transition-colors hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-100 dark:hover:bg-gray-700"
          >
            Настройки
          </button>
        </div>
      </header>

      <main className="flex flex-1 flex-col gap-6 p-5">
        <section className="rounded-2xl border border-gray-200 bg-gray-50/80 p-5 dark:border-gray-700 dark:bg-gray-800/50">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Лента анкет</h2>
          {feedLoading ? (
            <p className="mt-3 text-gray-600 dark:text-gray-400">Проверяем ленту…</p>
          ) : hasFeed ? (
            <p className="mt-3 text-gray-700 dark:text-gray-300">
              Есть анкеты, которые подходят под твои фильтры. Свайпни вправо — симпатия, влево — пропуск.
            </p>
          ) : (
            <p className="mt-3 text-gray-700 dark:text-gray-300">
              Сейчас некого показать: лента пуста или все анкеты уже просмотрены. Зайди позже или расширь фильтры в
              настройках поиска.
            </p>
          )}
          <button
            type="button"
            disabled={feedLoading || !hasFeed}
            onClick={() => navigate('/feed')}
            className="mt-4 w-full rounded-xl bg-accent py-3.5 text-center text-base font-semibold text-white shadow-sm transition-opacity disabled:cursor-not-allowed disabled:bg-gray-300 disabled:text-gray-500 dark:disabled:bg-gray-600 dark:disabled:text-gray-400"
          >
            Посмотреть анкеты
          </button>
        </section>

        <section className="rounded-2xl border border-gray-200 p-5 dark:border-gray-700">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">История свайпов</h2>
          <p className="mt-1 text-sm text-gray-600 dark:text-gray-400">
            Списки людей, которых ты пропустил, и тех, кому поставил симпатию.
          </p>
          <div className="mt-4 flex flex-col gap-3">
            <button
              type="button"
              onClick={() => navigate('/review/skipped')}
              className="flex w-full items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 text-left font-medium text-gray-900 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700/80"
            >
              <span>Отсеянные</span>
              <span className="text-gray-400">→</span>
            </button>
            <button
              type="button"
              onClick={() => navigate('/review/liked')}
              className="flex w-full items-center justify-between rounded-xl border border-gray-200 bg-white px-4 py-3 text-left font-medium text-gray-900 transition-colors hover:bg-gray-50 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700/80"
            >
              <span>Симпатии</span>
              <span className="text-gray-400">→</span>
            </button>
          </div>
        </section>

        <section className="rounded-2xl border border-gray-200 p-5 dark:border-gray-700">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">Мэтчи</h2>
          {matchesLoading ? (
            <p className="mt-2 text-gray-600 dark:text-gray-400">Загрузка…</p>
          ) : matchCount > 0 ? (
            <p className="mt-2 text-gray-700 dark:text-gray-300">У тебя {matchCount} взаимных симпатий.</p>
          ) : (
            <p className="mt-2 text-gray-600 dark:text-gray-400">Пока нет мэтчей — продолжай смотреть анкеты.</p>
          )}
          <button
            type="button"
            onClick={() => navigate('/matches')}
            className="mt-4 w-full rounded-xl border border-accent/40 bg-accent/10 py-3 text-center font-semibold text-accent transition-colors hover:bg-accent/15"
          >
            Открыть чаты
          </button>
        </section>
      </main>
    </div>
  )
}
